export default "__VITE_ASSET__04355cf4__"